import { isDateRange, useActiveModifiers, useDayPicker, useFocusContext, useNavigation } from "react-day-picker";
import { isSameDay } from "date-fns";
import { useDateRangePickerContext } from "../date-range-picker/DateRangePickerContext";
export const useTabWithinRange = ({ date, displayMonth }) => {
    const { selected } = useDayPicker();
    const { range_start, range_end, range_middle } = useActiveModifiers(date, displayMonth);
    const { focusStart, focusEnd } = useDateRangePickerContext();
    const focusContext = useFocusContext();
    const { goToDate } = useNavigation();
    // Make start and end dates tab-focusable
    const tabWithinRange = (e) => {
        if (e.key !== "Tab" || !isDateRange(selected)) {
            return;
        }
        const { to, from } = selected;
        // only hijack if there are range bounds to jump between
        if (!(range_start || range_end || range_middle) || !to || !from || isSameDay(from, to)) {
            return;
        }
        // Should tab to range end
        if ((range_start || range_middle) && !e.shiftKey) {
            e.preventDefault();
            goToDate(to);
            focusContext.focus(to);
            focusEnd();
        }
        else if ((range_end || range_middle) && e.shiftKey) {
            // Should tab to range start
            e.preventDefault();
            goToDate(from);
            focusContext.focus(from);
            focusStart();
        }
    };
    return { tabWithinRange };
};
